import { BatchClassConfig } from "../../models/config/BatchClassConfig";
import { BatchClassMetadataData } from "../../models/config/BatchClassMetadata";
import RealRolePermission from "../../models/RealRolePermission";
import { useLicenseDetails } from "../licensing/useLicenseDetails";
import { Logo } from "../Logo";
import { ActionBar } from "./ActionBar";
import { ActionBarCategory } from "./ActionBarCategory";
import { BatchClassCategory } from "./BatchClassCategory";
import { Fluffer } from "./items/Fluffer";
import { Img } from "./items/Img";
import { Link } from "./items/Link";
import { Text } from "./items/Text";
import { Triangle } from "./items/Triangle";

export { CrudActionBar };
export type Items =
  | "search_model"
  | "add_model"
  | "import_model"
  | "export_model"
  | "import_batch"
  | "export_batch"
  | "import_new_bcc"
  | "import_update_bcc"
  | "export_bcc"
  | "bcc_settings"
  | "role_settings"
  | "license_details"
  | "tokens"
  | "batch_recycle_bin";
type Props = {
  batchClassId: string;
  status:
    | "loading"
    | "modelSearch"
    | "createModel"
    | "modelImport"
    | "batchImport"
    | "modelExport"
    | "batchExport"
    | "newBccImport"
    | "updateBccImport"
    | "bccExport"
    | "batchClassConfiguration"
    | "rolePermissions"
    | "licenseDetails"
    | "tokens"
    | "batchRecycleBin"
    | "loading_bccs"
    | "loading_bis"
    | "deleting_batch_instance"
    | "reprocessing_batch_instance"
    | "saving_models"
    | "refreshing_model"
    | "loaded";
  itemSelected: (item: Items) => void;
  batchClassConfig?: BatchClassConfig;
  batchClassConfigs: BatchClassMetadataData[];
  changeBcc: (batchClassConfig: BatchClassMetadataData) => void;
  logout: () => Promise<void>;
};
const CrudActionBar = (props: Props) => {
  const [licenseDetails] = useLicenseDetails();
  return (
    <ActionBar>
      <Img className={"disabled logo"}>
        <Logo />
      </Img>
      <Triangle />

      <Link href={`index.html#/${props.batchClassId}`}>Accelerator</Link>

      {licenseDetails?.reporting && <Link href={`reports.html`}>Reports</Link>}

      {props.status !== "loading" && (
        <>
          <ActionBarCategory
            title={"Templates"}
            underlined={["modelSearch", "createModel"].includes(props.status)}
          >
            <Text onClick={() => props.itemSelected("search_model")}>
              Search Templates
            </Text>
            {/* 
                        <Text onClick={() => props.itemSelected('add_model')}>
                            Add New Template
                        </Text> */}
          </ActionBarCategory>

          <ActionBarCategory
            title={"Import/Export"}
            underlined={[
              "modelImport",
              "batchImport",
              "modelExport",
              "batchExport",
              "newBccImport",
              "updateBccImport",
              "bccExport",
            ].includes(props.status)}
          >
            <Text
              onClick={() => props.itemSelected("import_batch")}
              disabled={
                !RealRolePermission.canSeeBatchMigration() ||
                props.batchClassConfigs.length === 0
              }
            >
              Import Batches
            </Text>

            <Text
              onClick={() => props.itemSelected("export_batch")}
              disabled={
                !RealRolePermission.canSeeBatchMigration() ||
                props.batchClassConfigs.length === 0
              }
            >
              Export Batches
            </Text>

            <Text
              onClick={() => props.itemSelected("import_model")}
              disabled={
                !RealRolePermission.canSeeModelMigration() ||
                props.batchClassConfigs.length === 0
              }
            >
              Import Templates
            </Text>

            <Text
              onClick={() => props.itemSelected("export_model")}
              disabled={
                !RealRolePermission.canSeeModelMigration() ||
                props.batchClassConfigs.length === 0
              }
            >
              Export Templates
            </Text>

            <Text
              onClick={() => props.itemSelected("import_new_bcc")}
              disabled={!RealRolePermission.canSeeBccMigration()}
            >
              New Batch Class
            </Text>

            <Text
              onClick={() => props.itemSelected("import_update_bcc")}
              disabled={
                !RealRolePermission.canSeeBccMigration() ||
                props.batchClassConfigs.length === 0
              }
            >
              Update Batch Class
            </Text>

            <Text
              onClick={() => props.itemSelected("export_bcc")}
              disabled={
                !RealRolePermission.canSeeBccMigration() ||
                props.batchClassConfigs.length === 0
              }
            >
              Export Batch Class
            </Text>
          </ActionBarCategory>

          <ActionBarCategory
            title={"Settings"}
            underlined={[
              "batchClassConfiguration",
              "rolePermissions",
              "licenseDetails",
              "batchRecycleBin",
            ].includes(props.status)}
          >
            <Text
              onClick={() => props.itemSelected("bcc_settings")}
              disabled={
                !RealRolePermission.canRolesEditBcc(props.batchClassConfig) ||
                props.batchClassConfigs.length === 0
              }
            >
              Batch Class Settings
            </Text>
            <Text
              onClick={() => props.itemSelected("role_settings")}
              disabled={!RealRolePermission.canSeeRolePermissions()}
            >
              Role Permissions
            </Text>
            <Text
              onClick={() => props.itemSelected("batch_recycle_bin")}
              disabled={props.batchClassConfigs.length === 0}
            >
              Batch Recycle Bin
            </Text>
            <Text onClick={() => props.itemSelected("license_details")}>
              License Details
            </Text>
            <Text onClick={() => props.itemSelected("tokens")}>API Tokens</Text>
          </ActionBarCategory>

          <Fluffer />

          <BatchClassCategory
            batchClassConfigs={props.batchClassConfigs}
            changeBcc={props.changeBcc}
            batchClassConfig={props.batchClassConfig}
          />

          <Text onClick={props.logout}>Logout</Text>
        </>
      )}
    </ActionBar>
  );
};
